export const errorResponses = {
  500: {
    code: 500,
    message: 'General error',
    statusCode: 500,
  },
  400: {
    code: 400,
    message: 'Invalid input data',
    statusCode: 400,
  },
  401: {
    code: 401,
    message: 'Unauthorized access',
    statusCode: 401,
  },
  404: {
    code: 404,
    message: 'File not found',
    statusCode: 404,
  },
  403: {
    code: 403,
    message: 'Forbidden access',
    statusCode: 403,
  },
  409: {
    code: 409,
    message: 'Conflict detected',
    statusCode: 409,
  },
  200: {
    code: 200,
    message: 'Success',
    statusCode: 200,
  },
  201: {
    code: 201,
    message: 'Created',
    statusCode: 201,
  },
}
